import { Box } from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import { toast } from 'react-toastify';
import { TableContainer, Table, Thead, Tbody, Tr, Th, Td, Button, Stack } from '@chakra-ui/react';
import { Flex, Avatar, Text, Heading, useColorModeValue } from '@chakra-ui/react';
import Card from "components/card/Card";
import Loader from "components/loader/loader";
import { professionalDetails } from "service/axiosClient";
import { CloseIcon } from '@chakra-ui/icons'

export default function Overview({ uniqueId, closeProfessionalCard, handleBottomScroll }) {
  const [professionalExportDetails, setprofessionalExportDetails] = useState([]);
  const [isLoading, setisLoading] = useState(false);
  const [isDataLoaded, setisDataLoaded] = useState(false);

  useEffect(() => {
    getProfessionalDetails();
  }, [uniqueId]);

  const getProfessionalDetails = async () => {
    try {
      setisLoading(true);
      let data = { uniqueId: uniqueId };
      const response = (await professionalDetails(data)).data;
      if (response.success) {
        setprofessionalExportDetails(response.data[0]);
        setisLoading(false);
        setisDataLoaded(true);
        handleBottomScroll();
      } else {
        toast.error(response.message);
        setisLoading(false);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setisLoading(false);
      toast.error(error.response.data.message);
      closeProfessionalCard();
    }
  };
  const closeProfessionalDetailCard = () => {
    closeProfessionalCard();
  }
  const bg = useColorModeValue('gray.100', 'gray.700');
  function capitalizeFirstLetter(str) {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  const languages = {
    it: "Italian",
    en: "English"
  };
  const displayValue = (value) =>
    value === null || value === undefined || value === '' ? 'N/A' : value;


  if (isDataLoaded) {
    return (
      <Box pt={{ base: "130px", md: "20px", xl: "20px" }} bg={bg} boxShadow={'2xl'} rounded={'lg'} textAlign={'center'}>
        {isLoading && <Loader />}
        <Stack paddingRight={5} direction="row" justifyContent={'end'} >
          <CloseIcon boxSize={5} cursor={"pointer"} onClick={closeProfessionalDetailCard} />
        </Stack>
        {professionalExportDetails && (
          <Card p={6} borderRadius="2xl" boxShadow="xl">
            <Flex direction="column" align="center" justify="center">
              <Avatar
                size="xl"
                src={professionalExportDetails.compressedImageUrl}
                alt="User Avatar"
                mb={4}
              />
              <Heading fontSize="2xl" fontFamily="body" mb={6}>
                {capitalizeFirstLetter(professionalExportDetails.firstName)} {professionalExportDetails.lastName}
              </Heading>

              <Box width="100%" maxW="600px">
                <Table variant="simple" size="md">
                  <Tbody>
                    <Tr>
                      <Td fontWeight="bold">Email</Td>
                      <Td>{displayValue(professionalExportDetails.email)}</Td>
                    </Tr>
                    <Tr>
                      <Td fontWeight="bold">Phone</Td>
                      <Td>{displayValue(professionalExportDetails.mobile)}</Td>
                    </Tr>
                    <Tr>
                      <Td fontWeight="bold">Gender</Td>
                      <Td>{displayValue(professionalExportDetails.gender)}</Td>
                    </Tr>
                    <Tr>
                      <Td fontWeight="bold">Language</Td>
                      <Td>{displayValue(languages[professionalExportDetails.lang])}</Td>
                    </Tr>
                    <Tr>
                      <Td fontWeight="bold">Country</Td>
                      <Td>{displayValue(capitalizeFirstLetter(professionalExportDetails.country))}</Td>
                    </Tr>
                    <Tr>
                      <Td fontWeight="bold">City</Td>
                      <Td>{displayValue(capitalizeFirstLetter(professionalExportDetails.city))}</Td>
                    </Tr>
                    <Tr>
                      <Td fontWeight="bold">Experience</Td>
                      <Td>{professionalExportDetails.experience ? `${professionalExportDetails.experience} Years` : 'N/A'}</Td>
                    </Tr>
                  </Tbody>
                </Table>
              </Box>
            </Flex>
          </Card>
        )}
      </Box>
    );
  } else {
    return (
      <> {isLoading && <Loader />}</>
    )
  }
}